@if (pdfLoaded) {
  <iframe [src]='pdfUrl()' type="application/pdf" width="100%" height="2000px" style="overflow: auto;" >
  </iframe>
}

